import { Box, Stack, Typography } from '@mui/material';
import { getFullName } from '@provision/formatting-utils';
import { useCallback } from 'react';
import { PlatformUserAvatar } from 'src/components';
import { UpdateUserFormFields } from 'src/components/UpdateUserModal/types';
import { ServerPlatformUserRaw } from 'src/graphql';
import { Modals, useShowModals } from 'src/store/modals';
import { PlatformUserRaw } from 'src/types';
import { SignalOnCallScheduleManagementMenu } from './signal-oncall-schedule-menu';

export interface Agent {
  ownerId: string;
  partnerId: number;
  name: string;
  email: string;
  cognitoUsername: string;
  userGroups: string[];
  userGroupRules?: string[];
}

export const SignalOnCallScheduleAgentsList = ({
  agents,
  onUserUpdate,
}: {
  agents: ServerPlatformUserRaw[];
  onUserUpdate: (data: Partial<PlatformUserRaw>) => Promise<void>;
}) => {
  const [showModalUpdateUserModal] = useShowModals(Modals.UpdateUser);

  const onEditOptionClick = useCallback(
    (user: ServerPlatformUserRaw) => {
      showModalUpdateUserModal({
        user,
        onSubmit: onUserUpdate,
        disabledFields: [
          UpdateUserFormFields.FirstName,
          UpdateUserFormFields.LastName,
          UpdateUserFormFields.Email,
        ],
      });
    },
    [onUserUpdate, showModalUpdateUserModal],
  );

  return (
    <Box p="1rem 1rem 3rem 1rem" minHeight={0} flexGrow={1}>
      <Typography variant="subtitle2" marginBottom="1rem">
        On Call Agents
      </Typography>
      <Stack
        spacing={1}
        sx={{
          height: '100%',
          overflow: 'auto',
        }}
      >
        {agents.map((agent) => {
          return (
            <Box display="flex" flexDirection="row" alignItems="center" key={agent.id}>
              <PlatformUserAvatar
                name={getFullName(agent)}
                partnerId={agent.partnerId}
                avatarFileKey={agent.avatarFileKey}
                sx={{
                  width: 25,
                  height: 25,
                  fontSize: (theme) => theme.utils.important('0.65rem'),
                }}
              />
              <Typography marginLeft="0.5rem" variant="body2">
                {getFullName(agent)}
              </Typography>
              <SignalOnCallScheduleManagementMenu
                user={agent}
                partnerId={agent.partnerId}
                onEditOptionClick={onEditOptionClick}
              />
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};
